import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    height: '100vh',
    position: 'relative',
  },

  popper: {
    display: 'flex',
    width: theme.spacing(40),
    bottom: theme.spacing(2),
    right: theme.spacing(52),
    height: theme.spacing(62),
    paddingBottom: theme.spacing(1),
    zIndex: 1,
  },

  charPreviewContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(52),
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(40),
    padding: theme.spacing(1),
    justifyContent: 'space-between',
    border: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
  },

  content: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    border: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
  },

  button: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(52),
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(3),

    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));
